exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n\n.fonts_proximaNovaRegular_1jdu9 {\n  font-family: 'proxima-nova', sans-serif;\n  font-weight: 400;\n}\n\n.fonts_proximaNovaMedium_2v2sr {\n  font-family: 'proxima-nova', sans-serif;\n  font-weight: 500;\n}\n\n.fonts_proximaNovaSemiBold_3K7sa {\n  font-family: 'proxima-nova', sans-serif;\n  font-weight: 600;\n}\n\n.fonts_proximaNovaBold_bq8PM {\n  font-family: 'proxima-nova', sans-serif;\n  font-weight: 700;\n}\n\n.fonts_proximaNovaExtraBold_3OujN {\n  font-family: 'proxima-nova', sans-serif;\n  font-weight: 800;\n}\n", ""]);

// exports
exports.locals = {
	"proximaNovaRegular": "fonts_proximaNovaRegular_1jdu9",
	"proximaNovaMedium": "fonts_proximaNovaMedium_2v2sr",
	"proximaNovaSemiBold": "fonts_proximaNovaSemiBold_3K7sa",
	"proximaNovaBold": "fonts_proximaNovaBold_bq8PM",
	"proximaNovaExtraBold": "fonts_proximaNovaExtraBold_3OujN"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]_[local]_[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/fonts.css
// module id = 3
// module chunks = 0